import { render, staticRenderFns } from "./ModalConfirmarAprovacao.vue?vue&type=template&id=69baa487&lang=pug"
import script from "./ModalConfirmarAprovacao.vue?vue&type=script&lang=js"
export * from "./ModalConfirmarAprovacao.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmarAprovacao.vue?vue&type=style&index=0&id=69baa487&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports